import { Badge, Table } from "flowbite-react";
import TablePagination from "./Pagination";
import { DataGridPagination } from "@/sharedTypes";

interface DataTableProps {
  columns: { key: string; label: string; render?: (row: any) => JSX.Element }[];
  data: { [key: string]: any }[];
  pagination: DataGridPagination;
  onPageChange: (newPageIndex: number) => void;
}

function DataTable({
  columns,
  data,
  pagination,
  onPageChange,
}: DataTableProps) {
  return (
    <div className="space-y-7">
      <Table>
        <Table.Head>
          {columns?.map((column) => (
            <Table.HeadCell key={column.key} className="py-2">
              {column.label}
            </Table.HeadCell>
          ))}
        </Table.Head>
        <Table.Body>
          {data?.length > 0 ? (
            data.map((row, rowIndex) => (
              <Table.Row key={rowIndex} className="py-4">
                {" "}
                {/* Reduced padding */}
                {columns?.map((column) => (
                  <Table.Cell key={column.key} className="py-3">
                    {" "}
                    {/* Reduced padding */}
                    {column.render ? (
                      column.render(row) // Render custom content if `render` is provided
                    ) : column.key === "status" ? (
                      <Badge
                        color={
                          row[column.key]?.toLowerCase() === "completed"
                            ? "success"
                            : row[column.key]?.toLowerCase() === "resolved"
                              ? "blue"
                              : row[column.key]?.toLowerCase() === "open"
                                ? "warning"
                                : row[column.key]?.toLowerCase() === "closed"
                                  ? "dark"
                                  : "failure"
                        }
                        className="flex max-w-[100px] items-center justify-center"
                      >
                        {row[column.key]}
                      </Badge>
                    ) : (
                      row[column.key]
                    )}
                  </Table.Cell>
                ))}
              </Table.Row>
            ))
          ) : (
            <Table.Row>
              <Table.Cell
                colSpan={columns.length}
                className="py-10 text-center"
              >
                No data available.
              </Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
      {data?.length > 0 && (
        <TablePagination pagination={pagination} onPageChange={onPageChange} />
      )}
    </div>
  );
}

export default DataTable;
